export const iconSizes = {
  micro: { width: 9, height: 9 },
  standard: { width: 12, height: 12 },
};
